import { Component, OnInit, Input } from '@angular/core';
import {ModalController,NavController} from '@ionic/angular';
import {NgModel} from '@angular/forms'
import { DataService } from 'src/app/services/data.service';
@Component({
  selector: 'app-rich-text-box',
  templateUrl: './rich-text-box.page.html',
  styleUrls: ['./rich-text-box.page.scss'],
})
export class RichTextBoxPage implements OnInit {
  // @Input() data;
   @Input() text:any;
   @Input() title:any;
  constructor(public modal:ModalController,public db:DataService) { }

  ngOnInit() {
  
  }

  async get_value(){
    await this.modal.dismiss({data:this.text})
  }

}
